import React, { useState, useRef } from 'react';
import { Form, Input, Select, Button, message, Modal, Collapse } from 'antd';
import { withTranslation } from 'react-i18next';
import axios from 'axios';
import { changeUserRegion } from '../../axios';
import { storageGetItem, unique } from '../../utils/index';
import './index.less';

const Panel = Collapse.Panel;
const { TextArea } = Input;
const { Option } = Select;

const regionOptions = [
    { label: 'US', value: 'us' },
    { label: 'EU', value: 'eu' },
    { label: 'CA', value: 'ca' },
    { label: 'AU', value: 'au' },
];

function UpdateRegion(props) {
    const { t, form } = props;
    const [region, setRegion] = useState('us');
    const [countryList, setCountryList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [resultModal, setResultModal] = useState({
        visible: false, success: [], failed: []
    });

    const fetchCountries = async () => {
        setLoading(true);
        try {
            const casApiUrl = storageGetItem(localStorage, 'serverConfig') ? JSON.parse(storageGetItem(localStorage, 'serverConfig')).casServerUrl : ''
            const res = await axios.get(casApiUrl + '/api/common/country');
            const countryData = res.data.data;
            let list = [];
            if (Array.isArray(countryData)) {
                list = countryData;
            } else if (countryData && Array.isArray(countryData.countryList)) {
                list = countryData.countryList;
            }
            setCountryList(list);
        } catch (e) {
            setCountryList([]);
        }
        setLoading(false);
    };

    React.useEffect(() => {
        fetchCountries();
        // eslint-disable-next-line
    }, []);

    const handleRegionChange = value => {
        setRegion(value);
    };

    const handleSubmit = e => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (!err) {
                // Split emails by line break
                let emailList = (values.emails || '').split(/\r?\n/).map(e => e.trim()).filter(e => e);
                // Validate each email format
                const emailReg = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
                const invalid = emailList.filter(email => !emailReg.test(email));
                if (invalid.length > 0) {
                    message.info(t('EmailFormat') + invalid.join(', '));
                    return;
                }
                emailList = unique(emailList);
                // Handle form submission
                setSubmitLoading(true);
                const list = emailList.map(email => ({
                    email,
                    country: values.country
                }));
                changeUserRegion({ list: list, region: values.region }).then(res => {
                    if (res.code === 100000) {
                        const resultModal = { visible: true, success: [], failed: [] };
                        if (res.data) {
                            if (res.data.successEmailList && res.data.successEmailList.length > 0) {
                                resultModal.success = res.data.successEmailList;
                            }
                            if (res.data.failedEmailList && res.data.failedEmailList.length > 0) {
                                resultModal.failed = res.data.failedEmailList;
                            }
                        }
                        setResultModal(resultModal);
                        form.resetFields();
                    } else {
                        message.error((res.msg || t('Submit') + ' ' + t('Fail')));
                    }
                    setSubmitLoading(false);
                }).catch(() => {
                    message.error(t('Submit') + ' ' + t('Fail'));
                    setSubmitLoading(false);
                });
                //
                // console.log('Submitted data:', { ...values, emailList });
            }
        });
    };

    const { getFieldDecorator } = form;
    return (
        <>
            <div className="main-new">
                <div className="main-cotent update-region-page">
                    <div className='form-section'>
                        <h2>{t('UpdateRegionInfo')}</h2>
                        <Form
                            layout="vertical"
                            onSubmit={handleSubmit}
                            hideRequiredMark={false}
                        >
                            <Form.Item
                                label={t('Email')}
                                required
                                help={t('multipleEmailAddresses')}
                            >
                                {getFieldDecorator('emails', {
                                    rules: [
                                        { required: true, message: t('PleaseEnterEmail') },
                                        {
                                            validator: (rule, value, callback) => {
                                                if (value) {
                                                    const lines = value.split(/\r?\n/);
                                                    if (lines.length > 1000) {
                                                        callback(t('1000lines'));
                                                        return;
                                                    }
                                                }
                                                callback();
                                            }
                                        }
                                    ],
                                })(
                                    <TextArea rows={6} maxLength={1000 * 50} placeholder={t('PleaseEnterEmail')} />
                                )}
                            </Form.Item>
                            <Form.Item
                                label={t('Region')}
                                required
                            >
                                {getFieldDecorator('region', {
                                    initialValue: region,
                                    rules: [{ required: true, message: t('PleaseSelectRegion') }],
                                })(
                                    <Select onChange={handleRegionChange}>
                                        {regionOptions.map(opt => (
                                            <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                            <Form.Item
                                label={t('Country')}
                                help={t('countryUnchanged')}
                            >
                                {getFieldDecorator('country', {
                                    rules: [],
                                })(
                                    <Select
                                        loading={loading}
                                        placeholder={t('PleaseSelectCountry')}
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {countryList.map(c => (
                                            <Option key={c.code} value={c.code}>{c.name}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" loading={submitLoading}>{t('Submit')}</Button>
                            </Form.Item>
                        </Form>
                    </div>
                    <div className="note-section">
                        <div className="note-title">
                            ⓘ {t('importantNotes')}
                        </div>
                        <div className="note-content">
                            <p>{t('updateRegiontips1')}</p>
                            <p>{t('updateRegiontips2')}</p>
                        </div>
                    </div>

                </div>
            </div>
            <Modal
                title={t('SubmissionResults')}
                visible={resultModal.visible}
                maskClosable={false}
                onCancel={() => setResultModal({ ...resultModal, visible: false })}
                footer={null}
            >
                <Collapse bordered={false} defaultActiveKey={['success']}>
                    <Panel header={t('SuccessfulEmails', { count: resultModal.success.length })} key="success">
                        {resultModal.success.length > 0 ? (
                            <ul className="resultBox">
                                {resultModal.success.map(email => <li style={{ listStyle: 'none' }} key={email}>{email}</li>)}
                            </ul>
                        ) : <span>{t('None')}</span>}
                    </Panel>
                    <Panel header={t('FailedEmails', { count: resultModal.failed.length })} key="failed">
                        {resultModal.failed.length > 0 ? (
                            <ul className="resultBox">
                                {resultModal.failed.map(email => <li style={{ listStyle: 'none' }} key={email}>{email}</li>)}
                            </ul>
                        ) : <span>{t('None')}</span>}
                    </Panel>
                </Collapse>
            </Modal>
        </>
    );
}

export default withTranslation(['common'])(Form.create()(UpdateRegion));
